import Routers from "../constants/routers";

interface PageNavigationItem {
  path: string;
  title: string;
  children?: PageNavigationItem[];
}

export const getCurrentPageTitle = (pathname: string, navigation: PageNavigationItem[]): string => {
  const path = pathname.replace(/\/$/, "");
  const pages = navigation.flatMap((item) => [item, ...(item.children ?? [])]);
  pages.push(
    { path: Routers.Dashboard, title: "ダッシュボード" },
    { path: Routers.SystemSettings, title: "システム設定" },
    { path: Routers.SubrogationRequestRegisterCreate, title: "代位弁済請求登録" },
    { path: Routers.AffiliateInquiries, title: "加盟店お問い合わせ" },
    { path: Routers.ShopRegistrationApplies, title: "店舗登録申請管理" },
    { path: Routers.EquipmentWarranty, title: "設備保証契約" }
  );
  const page = pages
    .filter((item) => path === item.path || path.startsWith(`${item.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];
  if (!page) return "";
  if (path === page.path) return page.title;
  const suffix = path.endsWith("/edit") ? "編集" : /\/(new|create)$/.test(path) ? "登録" : "詳細";
  return `${page.title}／${suffix}`;
};
